import React from 'react';

type Props = {
  target: React.RefObject<HTMLElement>;
};

export default function useScrollToTarget({ target }: Props) {
  const moveToTargetHandler = () => {
    if (target.current) {
      const rect = target.current.getBoundingClientRect();
      const targetPosition = rect.top + window.scrollY;

      window.scrollTo({
        top: targetPosition,
      });
    }
  };

  return {
    moveToTargetHandler,
  };
}
